// extracted by mini-css-extract-plugin
export default {"up_icon":"style_up_icon__SSAC4"};